import { ColumnConfig, NavigateAction, Sorting } from '../../../elements/billboard/types';
import { ContentInstructions, CoreContents, FromSettingsInstruction } from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type BillboardOptions = {
  data?: DataOptionsFactory;
  grouping: string | FromSettingsInstruction;
  columns: ColumnConfig[];
  asCard?: boolean;
  highlight?: string | FromSettingsInstruction;
  highlightedBrands?: string[];
  highlightColumn?: string | FromSettingsInstruction;
  siblingBuffer?: number;
  title?: string;
  limit?: number;
  sorting?: Sorting;
  // isAllowedToDisplayEmptyState should be added on just one content to display the empty state when there is no data
  isAllowedToDisplayEmptyState?: boolean;
  brandsBillboardDataType?: string | FromSettingsInstruction;
  navigateConfig?: NavigateAction;
};

export class BillboardFactory extends ContentFactory {
  constructor(options: BillboardOptions) {
    const {
      data,
      grouping,
      highlight,
      highlightedBrands,
      highlightColumn,
      siblingBuffer,
      title,
      limit,
      sorting,
      columns,
      asCard,
      isAllowedToDisplayEmptyState,
      brandsBillboardDataType,
      navigateConfig,
    } = options;

    //test
    const instructions: ContentInstructions = {
      grouping:
        typeof grouping === 'string'
          ? {
              type: 'StringInstruction',
              instruction: grouping,
            }
          : grouping,
      columns: {
        type: 'ObjectInstruction',
        instruction: columns,
      },
      title: title
        ? {
            type: 'StringInstruction',
            instruction: title,
          }
        : undefined,
      limit: limit
        ? {
            type: 'NumberInstruction',
            instruction: limit,
          }
        : undefined,
      siblingBuffer: siblingBuffer
        ? {
            type: 'NumberInstruction',
            instruction: siblingBuffer,
          }
        : undefined,
      sorting: sorting
        ? {
            type: 'ObjectInstruction',
            instruction: sorting,
          }
        : undefined,
      isAllowedToDisplayEmptyState: {
        type: 'BooleanInstruction',
        instruction: isAllowedToDisplayEmptyState,
      },
      brandsBillboardDataType:
        typeof brandsBillboardDataType === 'string'
          ? {
              type: 'StringInstruction',
              instruction: brandsBillboardDataType,
            }
          : brandsBillboardDataType,
      navigateConfig: navigateConfig
        ? {
            type: 'ObjectInstruction',
            instruction: navigateConfig,
          }
        : undefined,
    };

    if (asCard !== undefined) {
      instructions.asCard = {
        type: 'BooleanInstruction',
        instruction: asCard,
      };
    }

    if (highlight) {
      instructions.highlight =
        typeof highlight === 'string'
          ? {
              type: 'StringInstruction',
              instruction: highlight,
            }
          : highlight;
    }
    instructions.highlightedBrands = {
      type: 'ObjectInstruction',
      instruction: highlightedBrands,
    };
    if (highlightColumn) {
      instructions.highlightColumn =
        typeof highlightColumn === 'string'
          ? {
              type: 'StringInstruction',
              instruction: highlightColumn,
            }
          : highlightColumn;
    }

    super(CoreContents.billboard, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
